// extracted by mini-css-extract-plugin
export default {"header":"DefaultPage_header__EfNWu","header__text":"DefaultPage_header__text__xYoH3"};